/**
 * Configuration Class
 * Responsible for All The Api Configuration for the Application
 */
import { ArabicFont } from '../../utils/Fonts'
import arMessages from './../../translations/ar.json'
import { LocalStorageService } from '../LocalStorageService'

const workspace_apis_url = process.env.REACT_APP_WORKSPACE_BASE_URL
const subscription_apis_url = process.env.REACT_APP_SUBSCRIPTION_BASE_URL

class Configuration {
  static WORKSPACE_BASE_URL = workspace_apis_url
  static SUBSCRIPTION_BASE_URL = subscription_apis_url
  static BASE_AuthURL = '/'
  static General_EndPoints = {
    SortBy: '/SortBy'
  }
  static User_EndPoints = {
    profile: '/user',
    countries: '/country'
  }
  static Workspace_EndPoints = {
    users: workspace_apis_url + '/admin/user',
    exportUsers: workspace_apis_url + '/admin/user/export',
    addAdmin: workspace_apis_url + '/admin/admin-user',
    currencies: workspace_apis_url + '/admin/currency',
    paymentClaims: workspace_apis_url + '/admin/payment-claim',
    exportPaymentClaims: workspace_apis_url + '/admin/payment-claim/export',
    paymentRequests: workspace_apis_url + '/admin/payment-request',
    exportPaymentRequests: workspace_apis_url + '/admin/payment-request/export',
    paymentReceipts: workspace_apis_url + '/admin/payment-receipt',
    exportPaymentReceipts: workspace_apis_url + '/admin/payment-receipt/export',
    activityLog: workspace_apis_url + '/admin/activity',
    permissions: workspace_apis_url + '/admin/permission',
    roles: workspace_apis_url + '/admin/role',
    settings: workspace_apis_url + '/admin/setting',
    pages: workspace_apis_url + '/admin/page',
    companies: workspace_apis_url + '/admin/company',
    exportCompanies: workspace_apis_url + '/admin/company/export',
    importUPTCP: workspace_apis_url + '/admin/uptcp-eligibility/import'
  }
  static Subscription_EndPoints = {
    boot: '/boot',
    users: subscription_apis_url + '/admin/user',
    exportUsers: subscription_apis_url + '/admin/user/export',
    addAdmin: subscription_apis_url + '/admin/admin-user',
    paymentRequests: subscription_apis_url + '/admin/payment-request',
    exportPaymentRequests: subscription_apis_url + '/admin/payment-request/export',
    paymentReceipts: subscription_apis_url + '/admin/payment-receipt',
    exportPaymentReceipts: subscription_apis_url + '/admin/payment-receipt/export',
    activityLog: subscription_apis_url + '/admin/activity',
    permissions: subscription_apis_url + '/admin/permission',
    roles: subscription_apis_url + '/admin/role',
    settings: subscription_apis_url + '/admin/setting',
    pages: subscription_apis_url + '/admin/page',
    categories: subscription_apis_url + '/admin/category',
    userGroups: subscription_apis_url + '/admin/user-group',
    userGroupsBulkImport: subscription_apis_url + '/admin/user-group/import',
    externalEntityGroups: subscription_apis_url + '/admin/external-entity-group',
    externalEntityGroupsBulkImport: subscription_apis_url + '/admin/external-entity-group/import',
    externalServiceHandler: subscription_apis_url + '/admin/external_service_handler',
    services: subscription_apis_url + '/admin/service',
    plans: subscription_apis_url + '/admin/plan',
    serviceHandlers: subscription_apis_url + '/admin/service_handler',
    promocodes: subscription_apis_url + '/admin/promo',
    promocodesBulkImport: subscription_apis_url + '/admin/promo/import',
    plansReport: subscription_apis_url + '/admin/reports/plan',
    exportPlansReport: subscription_apis_url + '/admin/reports/plan/export',
    servicesReport: subscription_apis_url + '/admin/reports/service',
    exportServicesReport: subscription_apis_url + '/admin/reports/service/export',
    subscriptionsReport: subscription_apis_url + '/admin/reports/subscription',
    exportSubscriptionsReport: subscription_apis_url + '/admin/reports/subscription/export'
  }
  static User_Config = {
    usersListLimit: parseInt(process.env.REACT_APP_USERS_LIST_LIMIT_PER_PAGE),
    userCompaniesLimit: parseInt(process.env.REACT_APP_USER_COMPANIES_LIMIT_PER_PAGE),
    userPaymentClaimsLimit: parseInt(process.env.REACT_APP_USER_PaymentClaims_LIMIT_PER_PAGE),
    userPaymentRequestsLimit: parseInt(process.env.REACT_APP_USER_PaymentRequests_LIMIT_PER_PAGE),
    userPaymentReceiptsLimit: parseInt(process.env.REACT_APP_USER_PaymentReceipts_LIMIT_PER_PAGE),
    userActivityLogLimit: parseInt(process.env.REACT_APP_USER_ActivityLog_LIMIT_PER_PAGE),
    userRolesLimit: parseInt(process.env.REACT_APP_USER_Roles_LIMIT_PER_PAGE),
    userPagesLimit: parseInt(process.env.REACT_APP_USER_Pages_LIMIT_PER_PAGE),
    userCurrenciesLimit: parseInt(process.env.REACT_APP_USER_Currencies_LIMIT_PER_PAGE),

    userCategoriesLimit: parseInt(process.env.REACT_APP_USER_Categories_LIMIT_PER_PAGE),
    userGroupsLimit: parseInt(process.env.REACT_APP_USER_UserGroups_LIMIT_PER_PAGE),
    externalEntityGroupsLimit: parseInt(process.env.REACT_APP_USER_ExternalEntityGroups_LIMIT_PER_PAGE),
    promocodesLimit: parseInt(process.env.REACT_APP_USER_Promocodes_LIMIT_PER_PAGE),
    userServicesLimit: parseInt(process.env.REACT_APP_USER_Services_LIMIT_PER_PAGE),
    userPlansLimit: parseInt(process.env.REACT_APP_USER_Plans_LIMIT_PER_PAGE),
    userServicesReportLimit: parseInt(process.env.REACT_APP_USER_ServicesReport_LIMIT_PER_PAGE),
    userPlansReportLimit: parseInt(process.env.REACT_APP_USER_PlansReport_LIMIT_PER_PAGE),
    userSubscriptionsReportLimit: parseInt(process.env.REACT_APP_USER_SubscriptionsReport_LIMIT_PER_PAGE),
  }

  static Keycloak_Config = {
    url: process.env.REACT_APP_Keycloak_URL,
    realm: process.env.REACT_APP_Keycloak_realm,
    clientId: process.env.REACT_APP_Keycloak_clientId
  }

  static FACEBOOK_CLIENT_ID = process.env.REACT_APP_FACEBOOK_CLIENT_ID
  static GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID
  static UPLOAD_FILE_SIZE = process.env.REACT_APP_UPLOAD_FILE_SIZE_IN_BYTES

  static Local = LocalStorageService.get('ETaxAdminAppLanguage')
  static DefaultLocale = 'ar'
  static DefaultDirection = 'rtl'
  static DefaultFont = ArabicFont
  static DefaultMessage = arMessages

  static isIOS = () => {
    return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  }
}

export default Configuration
